import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className="header">
            <div className="header-content">
                <div className="brand">
                    <div className="logo-mark"></div>
                    <h1>ub-tools</h1>
                </div>

                <button
                    className={`menu-toggle ${menuOpen ? 'active' : ''}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <nav className={`nav ${menuOpen ? 'active' : ''}`}>
                    <NavLink
                        to="/"
                        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                        onClick={() => setMenuOpen(false)}
                    >
                        Webapps
                    </NavLink>
                    <NavLink
                        to="/apps"
                        className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                        onClick={() => setMenuOpen(false)}
                    >
                        Applications
                    </NavLink>
                </nav>
            </div>
        </header>
    );
}

export default Header;
